/**
 * Assurance platform URLs.
 *
 * Set RAZZLE_ASSURANCE_BASE_URL in your .env or deployment environment.
 * All service URLs are derived as sub-paths of this base.
 */

const rawBase =
  typeof window !== 'undefined'
    ? (window.__ENV__?.ASSURANCE_BASE_URL ?? '')
    : (process.env.ASSURANCE_BASE_URL ?? '');
const BASE_URL = rawBase.endsWith('/') ? rawBase.slice(0, -1) : rawBase;

export const ASSURANCE_ISO24027_URL = `${BASE_URL}/iso24027/`;
export const ASSURANCE_LL144_URL = `${BASE_URL}/ll144/LL144_Analysis/`;
export const ASSURANCE_PREDICTIVE_AI_BIAS_URL = `${BASE_URL}/ll144/Predictive_AI_Bias_Analysis/`;
export const ASSURANCE_PII_URL = `${BASE_URL}/pii/`;
export const POLICY_NAVIGATOR_URL = `${BASE_URL}/policy-navigator/`;
export const RUN_TEST_URL =
  typeof window !== 'undefined'
    ? (window.__ENV__?.RUN_TEST_URL ?? '')
    : (process.env.RUN_TEST_URL ?? '');
